import { inject } from "@angular/core";
import { type ActivatedRouteSnapshot, type ResolveFn, Router } from "@angular/router";

import { catchError, of } from "rxjs";

import type { GridFull } from "../../shared/models";
import { SupplierService } from "../../supplier.service";

/**
 * Resolves grid data before activating the grid detail route.
 * Redirects to 404 if the grid is not found.
 */
export const gridDetailResolver: ResolveFn<GridFull | null> = (route: ActivatedRouteSnapshot) => {
  const supplierService = inject(SupplierService);
  const router = inject(Router);

  const supplierId = route.paramMap.get("id");
  const gridId = route.paramMap.get("gridId");

  if (!supplierId || !gridId) {
    router.navigate(["/404"]);
    return of(null);
  }

  return supplierService.getGrid(supplierId, gridId).pipe(
    catchError(() => {
      router.navigate(["/404"]);
      return of(null);
    }),
  );
};
